enum SchoolTypeEnum {
  Elementary = 1,
  High = 2
}

export default SchoolTypeEnum;
